import * as React from "react";
import { Typography, Tooltip, withStyles, IconButton } from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";
import { formatNumber } from "utils/MathUtils";

const PropTypes = require("prop-types");
const styles = (theme) => ({
  tablePropsWrapper: {
    marginTop: "3px",
  },
  tablePropsTitle: {
    fontFamily: "Raleway",
    padding: "8.5px",
    color: "#919191",
    fontWeight: "700" as any,
    letterSpacing: "1px" as any,
    fontSize: "9px",
  },
  tableProps: {
    width: "100%",
    background: "#363637",
    borderCollapse: "collapse" as any,
    border: "1px solid #2A292F",
  },
  tableItemTitle: {
    fontSize: "11px",
    padding: "2px",
    paddingLeft: "10px",
    color: "#C7C7C7",
    width: "40%",
    maxWidth: "40px",
    fontWeight: "500" as any,
    whiteSpace: "nowrap" as any,
    textOverflow: "ellipsis",
    overflow: "hidden",
    borderRight: "1px solid #2A292F",
  },
  tableItemProp: {
    fontSize: "11px",
    padding: "2px",
    paddingLeft: "10px",
    color: "#919191",
    width: "60%",
    maxWidth: "60px",
    whiteSpace: "nowrap" as any,
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  inputTableProp: {
    color: "inherit",
    width: "100%",
    height: 16,
    border: 0,
    fontSize: "inherit",
    padding: 0,
    backgroundColor: "unset",
  },
  icon: {
    color: "#A8A8A8",
    size: "11px",
    padding: "3px",
    alignItems: "middle",
    "&:disabled": {
      color: "red",
    },
  },
  iconWrap: {
    padding: "0 2px",
    "&:disabled": {
      "& > span > svg": {
        color: "gray",
      },
    },
  },
});

type IProps = {
  classes: any;
  elements: any[];
  includeBlankValues?: boolean;
  enableEdit?: boolean;
  formatNumbers?: boolean;
  onTitleBlur?: any;
  onValueBlur?: any;
  onDeleteClick?: any;
};

type ColumnProps = {
  id: string;
  value: string;
  classes: any;
  enableTootltip: boolean;
  enableInput?: boolean;
  onBlur: any;
};

const PropertiesTable = (props: IProps) => {
  const {
    classes,
    elements,
    includeBlankValues,
    enableEdit,
    onTitleBlur,
    onValueBlur,
    onDeleteClick,
  } = props;
  // PRUBK-844 - Se a propriedade não for definida então o valor padrão será true
  const formatNumberValues =
    props.formatNumbers == undefined ? true : props.formatNumbers;

  const Column = (props: ColumnProps) => {
    const value = props.value ? props.value : "";
    const columnEl = (
      <td className={props.classes.line}>
        {props.enableInput ? (
          <input
            style={{ outlineStyle: "none" }}
            type={"text"}
            autoComplete={"off"}
            className={props.classes.inputTableProp}
            defaultValue={value}
            onBlur={(ev) => {
              if (props.onBlur) props.onBlur(ev, props.id);
            }}
          />
        ) : (
          value
        )}
      </td>
    );
    return props.enableTootltip ? (
      <Tooltip title={value}>{columnEl}</Tooltip>
    ) : (
      columnEl
    );
  };

  function setValue(value) {
    let tooltipValue = true;
    if (!value && !includeBlankValues) value = false;
    // PRUBK-844 - Adicionar opção de formatar ou não um número
    else if (formatNumberValues && value && !isNaN(Number(value))) {
      // formata se for número
      value = formatNumber(value);
      tooltipValue = false;
    }
    return { value, tooltipValue };
  }

  return (
    <div className={classes.tablePropsWrapper}>
      {elements.map(({ title, props }, index) => (
        <div key={index}>
          <Typography className={classes.tablePropsTitle}>
            {title.toUpperCase()}
          </Typography>
          <table className={classes.tableProps}>
            <tbody>
              {props.map((property, trIndex) => {
                let title = property.title || property.label;
                let { value, tooltipValue } = setValue(property.value);
                return (
                  <tr
                    key={index + "." + trIndex}
                    style={{ border: "1px solid #2A292F", width: "100%" }}
                  >
                    <Column
                      id={property.id}
                      value={title}
                      classes={{ line: classes.tableItemTitle, ...classes }}
                      enableTootltip={true}
                      enableInput={enableEdit}
                      onBlur={onTitleBlur}
                    />
                    {value !== false && (
                      <Column
                        id={property.id}
                        value={value}
                        classes={{ line: classes.tableItemProp, ...classes }}
                        enableTootltip={tooltipValue}
                        enableInput={enableEdit}
                        onBlur={onValueBlur}
                      />
                    )}
                    {enableEdit && (
                      <td
                        className={classes.tableItemProp}
                        style={{ backgroundColor: "#2A292F" }}
                      >
                        <IconButton
                          className={classes.iconWrap}
                          aria-label="Delete"
                          onClick={(ev) => {
                            if (onDeleteClick) onDeleteClick(ev, property.id);
                          }}
                        >
                          <DeleteIcon className={classes.icon} />
                        </IconButton>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

PropertiesTable.propTypes = {
  onTitleBlur: PropTypes.func,
  onValueBlur: PropTypes.func,
  onDeleteClick: PropTypes.func,
};

export default withStyles(styles)(PropertiesTable);



// WEBPACK FOOTER //
// ./src/modules/customProperties/components/PropertiesTable.tsx